import React from 'react';
import LoaderHolder from './LoaderHolder';
import { LoaderHolderProps } from '../type';
import './WordStyle.scss';

function WordStyle(props: LoaderHolderProps) {
  return (
    <LoaderHolder
      className="elmo-loader-word"
      viewBoxHeight={35}
      viewBoxWidth={300}
      {...props}
    >
      <rect x="0" y="10" rx="4" ry="4" width="150" height="28" />
    </LoaderHolder>
  );
}

export default WordStyle;
